import { Box, styled, Typography } from '@mui/material';

export const Title = styled(Typography)({
  color      : '#231F20',
  fontFamily : 'Montserrat',
  fontWeight : '700',
});

export const CompletedSurveyWrapper = styled(Box)({
  width                   : '100%',
  height                  : '250px',
  maxWidth                : '485px',
  margin                  : '29px auto',
  textAlign               : 'center',
  display                 : 'flex',
  flexDirection           : 'column',
  justifyContent          : 'center',
  alignItems              : 'center',
  '& .MuiTypography-root' : {
    marginTop    : '6px',
    marginBottom : '6px',
  },
  '& svg' : {
    marginBottom : '18px',
  },
});
